import React from 'react';
import styled from 'styled-components';
import EditIcon from '@mui/icons-material/Edit';
import { UserDetailsDto } from '../../../services/User/userService.dto';
import { phoneUtils } from '../../../utils/phoneUtils';
import { useUpdatePhoneNumber } from '../hooks/useUpdatePhoneNumber';

const Container = styled.div`
  display: flex;
  padding-right: 20px;
  position: relative;
`;

const EditButton = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  justify-self: center;
`;

interface Props {
  user: UserDetailsDto;
  onUpdated?: () => void;
}

const PhoneNumberCell = ({ user, onUpdated }: Props) => {
  const { showUpdatePhoneNumberPopover } = useUpdatePhoneNumber(onUpdated);

  return (
    <Container>
      {phoneUtils.convertToPhoneDisplayNumber(user.phone)}
      {user.userStatus === 'CONFIRMED' && !user.blocked && (
        <EditButton onClick={() => showUpdatePhoneNumberPopover(user)}>
          <EditIcon style={{ fontSize: 18 }} />
        </EditButton>
      )}
    </Container>
  );
};

export default PhoneNumberCell;
